import { render, staticRenderFns } from "./TopBrokers.vue?vue&type=template&id=2ef3742a&"
import script from "./TopBrokers.vue?vue&type=script&lang=js&"
export * from "./TopBrokers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports